export { default } from './Typo';
export type { TypoProps } from './Typo';
